import React, { useState, useEffect } from 'react';
import '../../css/Pages.css';
import JobTitleListing from '../../components/CategoryManagement/JobTitle/JobTitleListing';
import JobTitleForm from '../../components/CategoryManagement/JobTitle/JobTitleForm';
import { useConfirmDeleteDialog } from '../../hooks/useConfirmDeleteDialog';
import { useCloseConfirmDialog } from '../../hooks/useCloseConfirmDialog';

const JobTitle = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newName, setNewName] = useState('');
    const [editId, setEditId] = useState(null);

    const [isDesktop, setIsDesktop] = useState(true);

    const { confirmDeleteDialog } = useConfirmDeleteDialog();
    const { confirmCloseDialog } = useCloseConfirmDialog();

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${API_BASE_URL}/jobtitle`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
                return;
            }

            if (response.ok) {
                const result = await response.json();
                if (Array.isArray(result)) {
                    setData(result);
                    setFilteredData(result);
                } else {
                    console.error("Lỗi: Dữ liệu API trả về không phải là mảng", result);
                    setData([]);
                    setFilteredData([]);
                }
            } else {
                console.error("Lỗi HTTP:", response.status);
                setData([]);
                setFilteredData([]);
            }
        } catch (error) {
            console.error("Lỗi tải dữ liệu:", error);
            setData([]);
            setFilteredData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        setFilteredData(data.filter(item => item.Name.toLowerCase().includes(query)));
    };

    const handleEdit = (item) => {
        setEditId(item.Id);
        setNewName(item.Name);
        setIsModalOpen(true);
    };

    const handleDelete = (id) => {
        confirmDeleteDialog({
            header: 'Xác nhận xóa',
            message: 'Bạn có chắc chắn muốn xóa chức danh này không?',
            accept: async () => {
                try {
                    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
                    const response = await fetch(`${API_BASE_URL}/jobtitle?id=${id}`, {
                        method: 'DELETE',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });

                    if (response.status === 401 || response.status === 403) {
                        localStorage.removeItem('user');
                        localStorage.removeItem('accessToken');
                        window.location.href = '/login';
                        return;
                    }

                    if (response.ok) {
                        fetchData();
                    } else {
                        alert("Xóa thất bại! Vui lòng kiểm tra lại quyền truy cập.");
                    }
                } catch (error) {
                    console.error("Lỗi xóa:", error);
                }
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newName.trim() === '') {
            alert("Vui lòng nhập tên chức danh!");
            return;
        }

        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const method = editId ? 'PUT' : 'POST';
            const body = editId ? { Id: editId, Name: newName } : { Name: newName };

            const response = await fetch(`${API_BASE_URL}/jobtitle`, {
                method,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
                return;
            }

            if (response.ok) {
                fetchData();
                closeModal();
            } else {
                alert("Lưu thất bại! Vui lòng kiểm tra lại quyền truy cập.");
            }
        } catch (error) {
            console.error("Lỗi lưu dữ liệu:", error);
        }
    };

    const closeModal = () => { setIsModalOpen(false); setNewName(''); setEditId(null); };

    return (
        <div className="page-container">
            <div
                className="page-header"
                style={isDesktop ? { marginBottom: '10px' } : { marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}
            >
                <div className="header-title">
                    <h2 style={isDesktop ? {} : { margin: 0 }}>DANH MỤC CHỨC DANH</h2>
                </div>
                <button
                    className="btn-add-new"
                    onClick={() => { setEditId(null); setNewName(''); setIsModalOpen(true); }}
                    style={isDesktop ? {} : { width: '100%', margin: 0 }}
                >
                    <i className="fa-solid fa-plus"></i> Thêm mới
                </button>
            </div>

            <div style={isDesktop
                ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', marginTop: '10px' }
                : { display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px', marginTop: '10px' }
            }>
                <p className="sub-title" style={{ margin: 0 }}>DANH SÁCH CHỨC DANH</p>

                <div style={isDesktop
                    ? { display: 'flex', gap: '10px' }
                    : { display: 'flex', gap: '10px', width: '100%', alignItems: 'stretch' }
                }>
                    <div style={isDesktop ? {} : { flex: 1 }}>
                        <input
                            type="text"
                            placeholder="Tra cứu chức danh"
                            className="form-input"
                            style={isDesktop
                                ? { width: '300px', padding: '8px 15px' }
                                : { width: '100%', padding: '8px 15px', boxSizing: 'border-box', height: '100%' }
                            }
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                    <button
                        onClick={fetchData}
                        className="btn-add-new"
                        style={isDesktop
                            ? { margin: 0, padding: '8px 15px', backgroundColor: '#6c757d' }
                            : { margin: 0, padding: '0', width: '45px', flex: '0 0 45px', backgroundColor: '#6c757d', display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        }
                        title="Tải lại dữ liệu"
                    >
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
            </div>

            <JobTitleListing
                data={filteredData}
                onEdit={handleEdit}
                onDelete={handleDelete}
                isLoading={isLoading}
                searchQuery={searchQuery}
            />

            <JobTitleForm
                isOpen={isModalOpen}
                onClose={() => (newName.trim() !== '' ? confirmCloseDialog(closeModal) : closeModal())}
                onSubmit={handleSubmit}
                newName={newName}
                setNewName={setNewName}
                isEditing={!!editId}
            />
        </div>
    );
};

export default JobTitle;